import classNames from "classnames";
import { useNavigate } from 'react-router-dom'
import { useRef, useEffect, useState } from 'react';
import { deadlineStatusEnum } from '../../services/EnumsService';
import { formatRelativeShort, truncateWordsDynamic } from '../../services/stringServices';

function OverdueProjectsOption ({to, editTo, project, children, className, activeClassName, handleOptionSelection, selected}){
    const navigate = useNavigate();
    const containerRef = useRef(null);
    const [displayedName, setDisplayedName] = useState(project.name);
    
    useEffect(() => {
        if (containerRef.current) {
            const width = containerRef.current.offsetWidth;
            setDisplayedName(truncateWordsDynamic(project.name, width));
        }
    }, [project.name]);
    const classes = classNames(
        'text-black', 
        className,
        selected === to && activeClassName
    );

    const handleClick = (event) => {
        if(event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        handleOptionSelection(to)
        navigate(to)
    }
    
    const renderProgressBar = (()=>{
        const progressPercentage = project.progress;
        const progressSteps = [
            { max: 20, className: "bg-green-200" },
            { max: 50, className: "bg-green-300" },
            { max: 80, className: "bg-green-400" },
            { max: 100, className: "bg-green-500" }
        ];
        const matchedStep = progressSteps.find((step) => progressPercentage <= step.max);
        const classNameProgress = `${matchedStep?.className ?? "bg-green-100"} h-2 rounded-full`;

        return (
            <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div 
                    className={classNameProgress}
                    style={{ width: `${progressPercentage}%` }}
                ></div>
            </div>
        );
    })

    return (
        <div className="w-full flex flex-col mt-4">
            <div className="w-full flex flex-row">
                <div ref={containerRef} className="w-[85%] font-bold text-l text-left ml-2 text-slate-500 ">{displayedName}</div>
                <div className="w-[15%] font-bold text-l text-right ml-2 " 
                style={{ color: `${deadlineStatusEnum(project.deadlineStatus).color}`}} >{formatRelativeShort(project.deadline)}</div>
            </div>
            {renderProgressBar()}
        </div>
    )
}

export default OverdueProjectsOption